import { ChangeDetectorRef, Component, Input, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-notification-box',
  imports: [],
  templateUrl: './notification-box.html',
  styles: ``,
})
export class NotificationBox {

  //@Input() message: string = '';

  protected _message: string = '';
  protected _bounceAnimation: string = '';
  private _bounce: boolean = false;

  constructor(private readonly cdr: ChangeDetectorRef) {}

/* listen for changes to the message property and call showError when it changes */
  // ngOnChanges(changes: SimpleChanges) {
  //   if (changes['message']) {
  //     this.showMessage(changes['message'].currentValue);
  //   }
  // }

  public showMessage(message: string) {

    if (message.trim() === '') {
      this._message = '';
      return;
    }

    console.log("showMessage():", message);

    this._message = message;
    this._bounce = false;
    this._bounceAnimation = 'none';
    this.cdr.detectChanges();

    setTimeout(() => {
      this._bounceAnimation = 'error-pop 300ms ease-out';
    }, 0);
  }

  public clearMessage() {
    this._message = '';
    this._bounceAnimation = 'none';
  }

}
